import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/runner/work/library-website-nuxt/library-website-nuxt/layouts/default.vue").then(m => m.default || m))
}